import axios from "axios";
import moment from "moment";
import qs from "qs";
import { ListGroup } from "react-bootstrap";
import { Link } from "react-router-dom";

import { useGetGroupedPpsQuery } from "api/memberPortal/project/protectionProfiles/protectionProfiles.api";
import ResponsiveMaterialTable from "components/UI/MaterialTable/ResponsiveMaterialTable";
import { useAuth } from "hooks/useAuth";
import { calculateActiveDaysInAM } from "utils/timeUtils";

export default function ACMRTable({ tableRef }) {
  const { authToken } = useAuth();

  const { data: projpps } = useGetGroupedPpsQuery();

  const acmrColumns = [
    {
      title: "Submitted On",
      render: (rowData) => {
        if (rowData?.current_assurance_maintenance.lab_request_date) {
          return moment
            .utc(rowData?.current_assurance_maintenance.lab_request_date)
            .format("MM/DD/YYYY");
        } else if (rowData?.current_assurance_maintenance.vendor_request_date) {
          return moment
            .utc(rowData?.current_assurance_maintenance.vendor_request_date)
            .format("MM/DD/YYYY");
        } else {
          return <>No Date</>;
        }
      },
    },
    {
      title: "VID",
      render: (rowData) => (
        <Link
          to={`/community/products/details/${rowData?.product_id}/assurancemaintenance/${rowData.current_assurance_maintenance?.maintenance_id}`}
          className="text-decoration-underline"
        >
          {rowData?.v_id}
        </Link>
      ),
    },
    {
      title: "Product Name",
      render: (rowData) => rowData.product_name,
    },
    {
      title: "PP Claim",
      render: (rowData) => (
        <ListGroup>
          {projpps &&
            projpps[rowData?.product_id]?.map((projpp) => (
              <ListGroup.Item key={projpp.pp_short_name} disabled>
                {projpp.pp_short_name}
              </ListGroup.Item>
            ))}
        </ListGroup>
      ),
    },
    {
      title: "CCTL",
      render: (rowData) => rowData.assigned_lab.name,
    },
    {
      title: "Requested By",
      render: (rowData) => rowData.vendor_id.name,
    },
    {
      title: "Due Date",
      field: "am_estimated_date",
      render: (rowData) =>
        rowData.current_assurance_maintenance?.team_due_date ? (
          moment
            .utc(rowData.current_assurance_maintenance?.team_due_date)
            .format("MM/DD/YYYY")
        ) : (
          <>No Date Set</>
        ),
    },
    {
      title: "Days in AM",
      render: (rowData) =>
        calculateActiveDaysInAM(rowData.current_assurance_maintenance),
    },
    {
      title: "AM Date",
      render: (rowData) =>
        moment.utc(rowData.assurance_maintenance_date).format("MM/DD/YYYY"),
    },
  ];

  const options = {
    sorting: true,
    columnsButton: true,
  };

  return (
    <>
      <ResponsiveMaterialTable
        title="ACMR's"
        tableRef={tableRef}
        data={(query) =>
          new Promise((resolve, reject) => {
            // Extract the necessary information from the query object
            const { page, pageSize, search, filters, orderBy, orderDirection } =
              query;

            let newFilters = filters.map((filter) => {
              let value = "";
              if (Array.isArray(filter.value)) {
                value = filter.value;
              } else {
                value = filter.value.replace(/['"]+/g, "");
              }
              return `"${filter.column.field.replace(/\./g, "__")}":"${value}"`;
            });
            const params = {
              offset: page * pageSize,
              limit: pageSize,
              search: search,
              filters: newFilters,
              orderBy: orderBy?.field,
              orderDirection: orderDirection,
            };
            axios
              .get(
                `${import.meta.env.VITE_DJANGO_ENDPOINT}project/product/niap_acmr/?${qs.stringify(params, { arrayFormat: "comma" })}`,
                {
                  withCredentials: true,
                  headers: {
                    Authorization: `Token ${authToken}`,
                  },
                },
              )
              .then((response) => {
                resolve({
                  data: response.data.results,
                  page: page,
                  totalCount: response.data.count,
                });
              })
              .catch((error) => {
                reject(error);
              });
          })
        }
        options={options}
        columns={acmrColumns}
      />
    </>
  );
}
